import React, { Fragment, useContext, useEffect, useState } from "react";

import { post } from 'axios';
// Provider
import { AppContext } from "../../../../../components/AppProvider";

// Utils
import { _O } from "../../../../../modules/utils";
import { userHabit } from "../../../../../modules/utils/UserHabit";

// UI
import {
  Container,
  DateLayer,
  DateTimeLayer,
  openLayerFn,
  closeLayerFn,
  pickerStart,
  openAlertPopup,
} from "../../../../Layout";

// Temp Images
import _T_MEAL from "../../../../../resources/images/user/user_meal_photo01.jpg";

import { PostApi1108 } from "../../../../../modules/network/padoPost";
import { maxLengthCheck } from "../../../../../modules/utils/CheckLogic";

export const TargetBPLayer = props => {
  const { trgtMaxBp, trgtMinBp, setTrgtMaxBp, setTrgtMinBp } = props;
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const request1108 = (userinfo, cfg, maxBp, minBp) => {
    PostApi1108(userinfo, cfg, phonecfg, maxBp, minBp)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          setTrgtMaxBp(maxBp);
          setTrgtMinBp(minBp);
          console.log(res.result);
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const setTrgtBp = () => {
    // input data varidate
    const trgtMaxBp = parseInt($("#trgtMaxBp").val());
    const trgtMinBp = parseInt($("#trgtMinBp").val());

    if (trgtMaxBp >= 0 && trgtMinBp >= 0 && trgtMaxBp > trgtMinBp) {
      request1108(userinfo, cfg, $("#trgtMaxBp").val(), $("#trgtMinBp").val());
    } else {
      openAlertPopup("목표혈압 값을 확인하세요.");
      return;
    }
  };

  useEffect(() => {
    //목표혈압 버튼 (레이어 열기)
    $(".btn-goalset").click(function () {
      openLayerFn($(".bloodgoal-layer"));
      userHabit(phonecfg, "BP100_P01");
    });
    //목표혈압 설정 레이어 닫기
    $(".bloodgoal-layer .tbns-area a").click(function () {
      closeLayerFn($(".bloodgoal-layer"));
    });
  }, [trgtMaxBp, trgtMinBp]);

  return (
    <div className="blacklayer-container bloodgoal-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div>
          <div className="blgrn-box vertical">
            <div className="blgr-title">목표혈압 설정</div>
            <div className="under-txt">
              담당의사와 상담한 목표 혈압 수치입니다.
            </div>

            <div className="inlayer-input-halfbox">
              <p className="hf-tit">최고혈압</p>
              <div>
                <div className="inp-with-unit fat">
                  {/* <input type="text" className="textbox fat num" id="trgtMaxBp" placeholder="최고혈압" maxLength="3" defaultValue={trgtMaxBp === 9999 ? 0 : trgtMaxBp} /> */}
                  <input
                    type="number"
                    pattern="\d*"
                    className="textbox fat num"
                    id="trgtMaxBp"
                    placeholder="최고혈압"
                    onChange={e => maxLengthCheck(e, 3)}
                    defaultValue={trgtMaxBp === 9999 ? 0 : trgtMaxBp}
                  />
                  <i>mmhg</i>
                </div>
              </div>
              <div>
                <p className="hf-tit">최저혈압</p>
                <div className="inp-with-unit fat">
                  {/* <input
                      type="text"
                      className="textbox fat num"
                      id="trgtMinBp"
                      placeholder="최저혈압"
                      maxLength="3"
                      defaultValue={trgtMinBp === 9999 ? 0 : trgtMinBp}
                    /> */}
                  <input
                    type="number"
                    pattern="\d*"
                    className="textbox fat num"
                    id="trgtMinBp"
                    placeholder="최저혈압"
                    onChange={e => maxLengthCheck(e, 3)}
                    defaultValue={trgtMinBp === 9999 ? 0 : trgtMinBp}
                  />
                  <i>mmhg</i>
                </div>
              </div>
            </div>

            <div className="tbns-area">
              <a href={void 0} className="btn-round gray">
                취소
              </a>
              <a href={void 0} className="btn-round wht" onClick={setTrgtBp}>
                확인
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};